<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col class="text-center title">行銷活動 / 會員集點任務管理</b-col>
    </b-row>
    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <b-tabs card class="tab_color">
              <b-tab title="升級正式會員活動設定" active>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="box-shadow p-3">
                      <div class="row mt-3">
                        <label class="control-label col-md-3">任務終止日期：</label>
                        <div class="col-md-3">
                          <input type="date" class="form-control" v-model="upgrade_expired_date" :disabled="!set_activity" :min="today" max="9999-12-31" @change="changeUpgradeExpired">
                          <div class="text-danger" v-if="valid_upgrade">{{valid_upgrade}}</div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <label class="control-label col-md-3">贈送點數：</label>
                        <div class="col-md-3">
                          <input type="number" class="form-control" v-model="upgrade_bonus" :disabled="!set_activity" min="0" max="9999">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-12">
                          <div class="float-right">
                            <button type="button" class="btn btn-ptc1" v-show="!set_activity" @click="edit" v-if="FunctionPermission > 1">編輯</button>
                            <button type="button" class="btn btn-save" v-show="set_activity" @click="confirm(1)">儲存</button>
                            <button type="button" class="btn btn-clear" v-show="set_activity" @click="confirm(2)">取消</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="推薦好友活動設定">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="box-shadow p-3">
                      <div class="row mt-3">
                        <label class="control-label col-md-3">任務終止日期：</label>
                        <div class="col-md-3">
                          <input type="date" class="form-control" v-model="recommend_expired_date" :disabled="!set_activity" :min="today" max="9999-12-31" @change="changeRecommendExpired">
                          <div class="text-danger" v-if="valid_recommend">{{valid_recommend}}</div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <label class="control-label col-md-3">被推薦者贈送點數：</label>
                        <div class="col-md-3">
                          <input type="number" class="form-control" v-model="recommend_bonus" :disabled="!set_activity" min="0" max="9999">
                        </div>
                      </div>
                      <div class="row mt-3">
                        <label class="control-label col-md-3">推薦者贈送點數：</label>
                        <div class="col-md-3">
                          <input type="number" class="form-control" v-model="referrer_bonus" :disabled="!set_activity" min="0" max="9999">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-12">
                          <div class="float-right">
                            <button type="button" class="btn btn-ptc1" v-show="!set_activity" @click="edit" v-if="FunctionPermission > 1">編輯</button>
                            <button type="button" class="btn btn-save" v-show="set_activity" @click="confirm(1)">儲存</button>
                            <button type="button" class="btn btn-clear" v-show="set_activity" @click="confirm(2)">取消</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="生日禮設定">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="box-shadow p-3">
                      <div class="row mt-3">
                        <label class="control-label col-md-3">任務終止日期：</label>
                        <div class="col-md-3">
                          <input type="date" class="form-control" v-model="birthday_expired_date" :disabled="!set_activity" :min="today" max="9999-12-31" @change="changeBirthdayExpired">
                          <div class="text-danger" v-if="valid_birthday">{{valid_birthday}}</div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <label class="control-label col-md-3">贈送點數：</label>
                        <div class="col-md-3">
                          <input type="number" class="form-control" v-model="birthday_bonus" :disabled="!set_activity" min="0" max="9999">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-12">
                          <div class="float-right">
                            <button type="button" class="btn btn-ptc1" v-show="!set_activity" @click="edit" v-if="FunctionPermission > 1">編輯</button>
                            <button type="button" class="btn btn-save" v-show="set_activity" @click="confirm(1)">儲存</button>
                            <button type="button" class="btn btn-clear" v-show="set_activity" @click="confirm(2)">取消</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>

       <!--Double Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="會員集點任務變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定儲存會員集點任務變更 ?</label>
            </div>
            <div class="row">
              <label class="control-label">升級正式會員活動</label>
            </div>
            <div class="row mb-2">
              <label class="col-lg-6">任務終止日期：</label>
              <label class="col-lg-6">{{upgrade_expired_date | formatDate}}</label>
              <label class="col-lg-6">贈送點數：</label>
              <label class="col-lg-6">{{upgrade_bonus}}</label>
            </div>
            <div class="row">
              <label class="control-label">推薦好友活動設定</label>
            </div>
            <div class="row mb-2">
              <label class="col-lg-6">任務終止日期：</label>
              <label class="col-lg-6">{{recommend_expired_date | formatDate}}</label>
              <label class="col-lg-6">被推薦者贈送點數：</label>
              <label class="col-lg-6">{{recommend_bonus}}</label>
              <label class="col-lg-6">推薦者贈送點數：</label>
              <label class="col-lg-6">{{referrer_bonus}}</label>
            </div>
            <div class="row">
              <label class="control-label">生日禮設定</label>
            </div>
            <div class="row mb-2">
              <label class="col-lg-6">任務終止日期：</label>
              <label class="col-lg-6">{{birthday_expired_date | formatDate}}</label>
              <label class="col-lg-6">贈送點數：</label>
              <label class="col-lg-6">{{birthday_bonus}}</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="confirm1">確定</b-btn>
              <b-btn variant="secondary" @click="cancel1">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

      <!-- Check Cancel Modal -->
      <b-modal ref="mdCancel" hide-footer title="會員集點任務變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定取消會員集點任務變更 ?</label>
            </div>
            <div class="float-right">
            <b-btn variant="primary" @click="confirm2">確定</b-btn>
            <b-btn variant="secondary" @click="cancel2">取消</b-btn>
          </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      birthday_expired_date: '',
      birthday_bonus: 0,
      upgrade_expired_date: '',
      upgrade_bonus: 0,
      recommend_expired_date: '',
      referrer_bonus: 0,
      recommend_bonus: 0,
      today: '',
      set_activity: false,
      valid_birthday: '',
      valid_upgrade: '',
      valid_recommend: '',
      FunctionPermission: 0
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F06') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    var date = new Date()
    var year = date.getFullYear()
    var mon = date.getMonth() + 1
    var day = date.getDate()

    if (mon < 10) {
      mon = '0' + mon
    }
    if (day < 10) {
      day = '0' + day
    }
    this.today = year + '-' + mon + '-' + day
    this.getNormalActivity()
  },
  methods: {
    edit () {
      this.set_activity = true
    },
    confirm (activy) {
      if (this.birthday_expired_date === this.item.BirthdayActivityExpiredAt.substring(0, 10) &&
          this.birthday_bonus === this.item.BirthdayBonus &&
          this.upgrade_expired_date === this.item.UpgradeActivityExpiredAt.substring(0, 10) &&
          this.recommend_expired_date === this.item.RecommendedActivityExpiredAt.substring(0, 10) &&
          this.upgrade_bonus == this.item.UpgradeBonus && //eslint-disable-line
          this.referrer_bonus == this.item.ReferrerBonus && this.recommend_bonus == this.item.RecommendedBonus) { //eslint-disable-line
        this.default()
      } else {
        if (activy === 1) {
          this.save()
        } else {
          this.$refs.mdCancel.show()
        }
      }
    },
    default () {
      this.valid_birthday = ''
      this.valid_upgrade = ''
      this.valid_recommend = ''
      this.set_activity = false
    },
    save () {
      if (this.valid_birthday || this.valid_upgrade || this.valid_recommend) {
      // if (this.valid_upgrade || this.valid_recommend) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    cancel2 () {
      this.$refs.mdCancel.hide()
    },
    confirm2 () {
      this.birthday_expired_date = this.item.BirthdayActivityExpiredAt.substring(0, 10)
      this.birthday_bonus = this.item.BirthdayBonus
      this.upgrade_expired_date = this.item.UpgradeActivityExpiredAt.substring(0, 10)
      this.upgrade_bonus = this.item.UpgradeBonus
      this.recommend_expired_date = this.item.RecommendedActivityExpiredAt.substring(0, 10)
      this.referrer_bonus = this.item.ReferrerBonus
      this.recommend_bonus = this.item.RecommendedBonus

      this.default()
      this.$refs.mdCancel.hide()
    },
    cancel1 () {
      this.$refs.mdCheck.hide()
    },
    confirm1 () {
      this.$refs.mdCheck.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/updatenormalactivity/v1', {
        id: this.id,
        birthdayExpiredDate: this.birthday_expired_date,
        birthdayBonus: this.birthday_bonus,
        upgradeExpiredDate: this.upgrade_expired_date,
        upgradeBonus: this.upgrade_bonus,
        recommendExpiredDate: this.recommend_expired_date,
        referrerBonus: this.referrer_bonus,
        recommendBonus: this.recommend_bonus
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)

          if (response.data.result === '0000') {
            miniToastr.success('會員集點任務已變更')
            this.item.BirthdayActivityExpiredAt = this.birthday_expired_date
            this.item.BirthdayBonus = this.birthday_bonus
            this.item.UpgradeActivityExpiredAt = this.upgrade_expired_date
            this.item.UpgradeBonus = this.upgrade_bonus
            this.item.RecommendedActivityExpiredAt = this.recommend_expired_date
            this.item.ReferrerBonus = this.referrer_bonus
            this.item.RecommendedBonus = this.recommend_bonus
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
            this.confirm2()
          }
        })
        .catch((error) => {
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
          this.confirm2()
        })
        .finally(() => {
          this.set_activity = false
          this.$parent.Loading = false
        })
    },
    getNormalActivity () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getnormalactivity/v1', {})
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)

          if (response.data.result === '0000') {
            this.item = response.data.data
            this.id = this.item.ID
            this.birthday_expired_date = this.item.BirthdayActivityExpiredAt.substring(0, 10)
            this.birthday_bonus = this.item.BirthdayBonus
            this.upgrade_expired_date = this.item.UpgradeActivityExpiredAt.substring(0, 10)
            this.upgrade_bonus = this.item.UpgradeBonus
            this.recommend_expired_date = this.item.RecommendedActivityExpiredAt.substring(0, 10)
            this.referrer_bonus = this.item.ReferrerBonus
            this.recommend_bonus = this.item.RecommendedBonus
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
        .finally(() => {
          this.$parent.Loading = false
        })
    },
    changeBirthdayExpired () {
      if (!this.birthday_expired_date) {
        this.valid_birthday = '日期格式不正確'
      } else if (this.birthday_expired_date < this.today) {
        this.valid_birthday = '任務終止日期不得小於系統日'
      } else {
        this.valid_birthday = ''
      }
    },
    changeUpgradeExpired () {
      if (!this.upgrade_expired_date) {
        this.valid_upgrade = '日期格式不正確'
      } else if (this.upgrade_expired_date < this.today) {
        this.valid_upgrade = '任務終止日期不得小於系統日'
      } else {
        this.valid_upgrade = ''
      }
    },
    changeRecommendExpired () {
      if (!this.recommend_expired_date) {
        this.valid_recommend = '日期格式不正確'
      } else if (this.recommend_expired_date < this.today) {
        this.valid_recommend = '任務終止日期不得小於系統日'
      } else {
        this.valid_recommend = ''
      }
    }
  },
  watch: {
    birthday_bonus: function (val) {
      if (val < 0 || !val) {
        this.birthday_bonus = 0
      } else if (val > 99999) {
        this.birthday_bonus = 99999
      } else {
        this.birthday_bonus = parseInt(val)
      }
    },
    upgrade_bonus: function (val) {
      if (val < 0 || !val) {
        this.upgrade_bonus = 0
      } else if (val > 99999) {
        this.upgrade_bonus = 99999
      } else {
        this.upgrade_bonus = parseInt(val)
      }
    },
    referrer_bonus: function (val) {
      if (val < 0 || !val) {
        this.referrer_bonus = 0
      } else if (val > 99999) {
        this.referrer_bonus = 99999
      } else {
        this.referrer_bonus = parseInt(val)
      }
    },
    recommend_bonus: function (val) {
      if (val < 0 || !val) {
        this.recommend_bonus = 0
      } else if (val > 99999) {
        this.recommend_bonus = 99999
      } else {
        this.recommend_bonus = parseInt(val)
      }
    }
  },
  filters: {
    formatDate: function (date) {
      return date.replace(/-/g, '/')
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #519b39;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/activity/List.vue